import React, { forwardRef } from 'react';
import { Spinner } from '../spinner';
import { StyledIconButtonProps } from '../';
import { IconButtonProps as MuiIconButtonProps } from '@mui/material';
import { StyledEditButton, Text } from './styled';

export const EditButton = forwardRef<HTMLButtonElement, MuiIconButtonProps & StyledIconButtonProps>(
  (props, ref) => (
    <StyledEditButton {...props} ref={ref}>
      {props?.loading ? (
        <Spinner
          type='circle'
          size={'small'}
          color={
            props.variant === 'contained'
              ? 'inherit'
              : props.color === 'inherit'
                ? 'default'
                : props.color
          }
        />
      ) : (
        <Text>{props.children}</Text>
      )}
    </StyledEditButton>
  )
);
